import castJSON from "../utils/cast-json";

const queryParser = ({ req }, next) => {
  req.query = JSON.parse(JSON.stringify(req.query), castJSON);
  return next();
};

export default queryParser;
